import React from 'react';
import './style.sass';
import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonSmallTitle from '../../../common-components/common-small-title';

const list = [
    {
        img: '/images/pic/topdf/topdf-results__img1.png',
        title: 'Конвертация PDF',
        text: `Первым сервисом, который мы&nbsp;запустили, был сервис конвертации различных форматов в&nbsp;PDF и&nbsp;наоборот. На&nbsp;старте мы&nbsp;поддерживали более 50&nbsp;форматов конвертации и&nbsp;почти 300&nbsp;направлений. В&nbsp;будущем планируем стать площадкой, которая поддерживает максимальное количество возможных преобразований по&nbsp;примеру работы с сервисом 
                  <a class="topdf__link" target="_blank" rel="noopener noreferrer nofollow" href="https://onlineconvertfree.com/">onlineconvertfree.com</a>.`,
    },
    {
        img: '/images/pic/topdf/topdf-results__img2.png',
        reverse: true,
        title: 'Распознавание PDF',
        text: 'Большой и важной задачей для нас является сервис распознавания текстов. Мы предоставили пользователям возможность преобразовывать онлайн отсканированные документы или фотографии в файлы Word, Excel и другие текстовые форматы. Для работы мы используем несколько специализированных библиотек, чтобы&nbsp;определить, какое из внедренных решений лучше применить в конкретном случае. Сегодня решение поддерживает 6 языков. И мы планируем постепенно увеличивать их количество.',
    },
    {
        img: '/images/pic/topdf/topdf-results__img3.png',
        title: 'Объединение PDF',
        text: 'Одна из&nbsp;самых популярных задач, с&nbsp;которой сталкиваются наши пользователи&nbsp;&mdash; это необходимость пакетного объединения разных PDF-файлов в&nbsp;один. Мы&nbsp;реализовали простой и&nbsp;удобный интерфейс, который позволяет это сделать в&nbsp;несколько кликов. А&nbsp;также дали возможность пользователям просто менять порядок документов в&nbsp;конечном PDF-файле.',
    },
];

class Results extends React.Component {
    constructor() {
        super();
        this.state = {
            showModal: false,
        };

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleOpenModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    render() {
        return (
            <ScrollAnimation
                delay={0}
                animateIn="fadeIn"
                offset={100}
                animateOnce={true}
                duration={1}
            >
                <FullWrapper className="topdf-results" bigPaddings={true}>
                    <CommonTitle className="topdf-results__title">Результаты</CommonTitle>
                    <div className="topdf-results__container">
                        {list.map(({ title, img, text, reverse }, index) => (
                            <ScrollAnimation
                                delay={0}
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                                className={
                                    reverse
                                        ? 'topdf-results__item topdf-results__item--reverse'
                                        : 'topdf-results__item'
                                }
                                key={index}
                            >
                                <div className="topdf-results__img" onClick={this.handleOpenModal}>
                                    <img src={img} alt="" loading="lazy" />
                                </div>
                                <div className="topdf-results__info">
                                    <CommonSmallTitle className="topdf-results__title-item">
                                        {title}
                                    </CommonSmallTitle>
                                    <CommonSmallText className="topdf-results__text-item">
                                        {parse(text)}
                                    </CommonSmallText>
                                </div>
                            </ScrollAnimation>
                        ))}
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Results;
